import styled from "styled-components";

const InputModal = ({ title, placeholder, value, onChange, isOpen, onClose, onConfirm }) => {
  return (
    <>
      {isOpen && (
        <Back >
          <Box>
            <h2>{title}</h2>
            <Input value={value} onChange={onChange} placeholder={placeholder}/>
            <Buttons>
              <ButtonCancel onClick={onClose}>{"취소"}</ButtonCancel>
              {onConfirm && <Button onClick={onConfirm}>확인</Button>}
            </Buttons>
          </Box>
        </Back>
      )}
    </>
  );
};

export default InputModal;

const Back = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

const Box = styled.div`
  background-color: white;
  width: 420px;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap:20px;
  animation-name: fadeInUp;
  animation-duration: 1s;

  h2 {
    margin-bottom: 0px;
  }
`;


const Buttons = styled.div`
  display: flex;
  gap: 10px;
`;

const ButtonCancel = styled.button`
  height: 50px;
  padding: 0 47px;
  background-color: white;
  border: 1px solid #007912;
  color: #007912;
  border-radius: 52px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: 0.3s;
`;

const Button = styled.button`
  height: 50px;
  padding: 0 47px;
  background-color: #007912;
  border: 1px solid #007912;
  color: white;
  border-radius: 52px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: 0.3s;
`;


const Input = styled.input`
    padding: 12px;
    border-radius: 20px;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid #C7CCD2;
    ::placeholder{
        color:#999;
    }
`